
<div class="schedule-summary border rounded p-4 bg-white" style="max-width: 100%;">
    <div class="row">
        <div class="col-md-6">
            <h5 class="mb-3" style="font-size: 16px; font-weight: 700;">Schedule Summary</h5>
            <div class="summary-row mb-2 mt-3" style="font-size: 14px; --label-width: 120px;">
                <span class="summary-label text-muted">Report Template:</span>
                <span class="summary-value">
                    {{ formattedCategory }} - {{ reportData.template_name || 'Default' }}
                </span>
            </div>
            <div class="summary-row mb-2" style="font-size: 14px; --label-width: 120px;">
                <span class="summary-label text-muted">Recipients:</span>
                <span class="summary-value">{{ recipientCount }}</span>
            </div>
            <div class="summary-row mb-2" style="font-size: 14px; --label-width: 120px;">
                <span class="summary-label text-muted">Created By:</span>
                <span class="summary-value">{{ reportData.created_by || 'Me' }}</span>
            </div>
        </div>
        <div class="col-md-6 pt-5">
            <div class="summary-row mb-2" style="font-size: 14px; --label-width: 100px;">
                <span class="summary-label text-muted">Frequency:</span>
                <span class="summary-value">{{ formattedFrequency }}</span>
            </div>
            <div class="summary-row mb-2" style="font-size: 14px; --label-width: 100px;">
                <span class="summary-label text-muted">{{ deliveryLabel }}:</span>
                <span class="summary-value">{{ formattedDeliveryDate }}</span>
            </div>
        </div>
    </div>
    
</div>
